// removed by extract-text-webpack-plugin
module.exports = {"ui":"_2r5nHJNk16eztOx0WdxD1t","container":"FQDtgUqgPAVt1yZAzHpvM","grid":"ozrTYZiFY16ONN6QNou5r","relaxed":"_2pfRFA4cXMJ-eHQ8RmFixj","very":"_1I9y6q5sDYGnu2EcPdAWJW","text":"_2xOBm1ZxM72TYhOSGRLiGD","fluid":"_3YbirwMEDYnwiPF3nOmgUa","justified":"j3gK8iksOmQTjzbCIDShP"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-css/components/container.min.css
// module id = 1749
// module chunks = 0